import React from 'react';
import ShopHero from './ShopHero';
import ShopProducts from './ShopProducts';
import { useSEO } from '../../hooks/useSEO';

const Shop: React.FC = () => {
  useSEO({
    title: 'Browse Medical Supplies',
    description: 'Explore our catalog of over 3,000 medical and laboratory products. Reliable medical distribution in Zimbabwe and Africa.',
    canonical: '/shop'
  });

  return (
    <main className="pt-20 bg-white">
      <ShopHero />
      <ShopProducts />
    </main>
  );
};

export default Shop;
